import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  HiChartBar, HiUsers, HiCreditCard, HiCube,
  HiCurrencyDollar, HiTrendingUp, HiNewspaper,
  HiCog, HiLogout, HiSwitchHorizontal, HiTag,
} from 'react-icons/hi';

const navItems = [
  { path: '/',             Icon: HiChartBar,         label: 'Dashboard'    },
  { path: '/users',        Icon: HiUsers,            label: 'Users'        },
  { path: '/transactions', Icon: HiCreditCard,       label: 'Transactions' },
  { path: '/products',     Icon: HiCube,             label: 'Products'     },
  { path: '/loans',        Icon: HiCurrencyDollar,   label: 'QueeKLoan'   },
  { path: '/vesttrades',   Icon: HiTrendingUp,       label: 'VestTrades'   },
  { path: '/news',         Icon: HiNewspaper,        label: 'News'         },
  { path: '/transfers',    Icon: HiSwitchHorizontal, label: 'Transfers'    },
  { path: '/promo-codes',  Icon: HiTag,              label: 'Promo Codes'  },
  { path: '/settings',     Icon: HiCog,              label: 'Settings'     },
];

export default function Sidebar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_info');
    navigate('/login');
  };

  return (
    <div className="sidebar">
      <div className="sidebar-logo">
        Vest<span>-Grow</span>{' '}
        <span style={{ fontSize: 11, opacity: 0.6, fontWeight: 400 }}>Admin</span>
      </div>
      <nav className="sidebar-nav">
        {navItems.map(({ path, Icon, label }) => (
          <div
            key={path}
            className={`nav-link ${pathname === path ? 'active' : ''}`}
            onClick={() => navigate(path)}
          >
            <span className="nav-icon" style={{ display: 'flex', alignItems: 'center' }}>
              <Icon size={17} />
            </span>
            <span>{label}</span>
          </div>
        ))}
      </nav>
      <div className="sidebar-footer">
        <div
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}
          onClick={logout}
        >
          <HiLogout size={16} />
          <span>Sign Out</span>
        </div>
      </div>
    </div>
  );
}
